import { LOAD_EMENDAS, SET_YEAR, EMENDAS_TOGGLE_LOADING } from './types'
import { request } from '@/request'

export const actions = {
  getEmendasAno(store, payload) {
    const { ano } = payload

    store.commit(SET_YEAR, ano)
    store.commit(EMENDAS_TOGGLE_LOADING)

    request
      .get('emendas/emendas-ano', {
        params: { ano: ano || new Date().getFullYear() }
      })
      .then(request => {
        const { data } = request
        store.commit(LOAD_EMENDAS, data)
      })
      .catch(error => {
        console.log(error.response)
      })
      .finally(() => {
        store.commit(EMENDAS_TOGGLE_LOADING)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/emendas_parlamentares/actions.js